<template>
  <ul class="c-nav c-nav--vertical">
    <li>
      <label
        :class="{
          'is-active' : bedroomState.length === 0,
        }"
        for="bedrooms-all"
        class="c-btn c-btn--invisible c-btn--vert-center"
      >
        <input
          id="bedrooms-all"
          v-model="bedroomState"
          :value="[]"
          type="radio"
          name="bedrooms"
          class="screen-reader-text"
        >
        <Toggle
          :isSelected="bedroomState.length === 0"
          class="c-btn__icon c-btn__icon--alignment"
        />
        Alle
      </label>
    </li>
    <li
      v-for="bedroom in bedrooms"
      :key="bedroom.id"
    >
      <label
        :for="'bedrooms-' + bedroom.id"
        :class="{
          'is-active' : bedroomState.includes(bedroom.name),
        }"
        class="c-btn c-btn--invisible c-btn--vert-center"
      >
        <input
          :id="'bedrooms-' + bedroom.id"
          v-model="bedroomState"
          :value="bedroom.name"
          type="checkbox"
          name="bedrooms"
          class="screen-reader-text"
        >
        <Toggle
          :isSelected="bedroomState.includes(bedroom.name) === true"
          class="c-btn__icon c-btn__icon--alignment"
        />
        {{ bedroom.name }} soverom
      </label>
    </li>
  </ul>
</template>

<script>
import Bedroom from '@/models/Bedroom';
import Residence from '@/models/Residence';

import Toggle from '@/components/Toggle.vue';


export default {
  name: 'SelectBedrooms',
  components: {
    Toggle,
  },
  computed: {
    bedrooms() {
      return Bedroom.all();
    },
    bedroomState: {
      get() {
        return this.$store.state.entities.residences.bedrooms;
      },
      set(bedrooms) {
        Residence.commit(state => {
          state.bedrooms = bedrooms;
        });
      },
    },
  },
};
</script>